<template>
  <div>
    <!-- 导航 -->
    <el-breadcrumb>
      <el-breadcrumb-item>
        <router-link to="./">首页</router-link>
      </el-breadcrumb-item>
      <el-breadcrumb-item>留学资源转化率</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 主体内容 -->
    <div class="content">
      <el-form inline label-position="right" label-width="80px" size="small" class="query-form">
        <el-form-item label="录入时间">
          <el-date-picker
            v-model="query.time"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="getList();"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="缴费时间">
          <el-date-picker
            v-model="query.timeone"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="getList();"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getList();">查询</el-button>
        </el-form-item>
      </el-form>

      <div style="height:20px;"></div>
      <el-card class="box-card collectCard" shadow="always" v-if="marketList.length>0">
        <div class="clearfix" slot="header">
          <span>总计转化率</span>
        </div>
        <div class="index-card" style="height:auto;">
          <el-col :span="4" class="stateItem">
            <div class="state">资源总数</div>
            <div class="person">
              <span style="color:#D82C34;font-size:14px;">{{total.totalCount}}人</span>
            </div>
          </el-col>
          <el-col :span="4" class="stateItem">
            <div class="state">签约人数</div>
            <div class="person">
              <span style="color:#D82C34;font-size:14px;">{{total.signCount}}人</span>
            </div>
          </el-col>
          <el-progress type="circle" :percentage="total.persent" color="#67c23a"></el-progress>
        </div>
      </el-card>
      <div style="height:20px;"></div>
      <el-card class="box-card collectCard" shadow="always" v-if="marketList.length>0">
        <div class="clearfix" slot="header">
          <span>营销团队转化率统计</span>
        </div>
        <div class="index-card" style="height:auto;">
          <!-- 列表定义 -->
          <el-table
            v-loading="loading"
            :data="marketList"
            border
            stripe
            style="width:100%;"
            show-summary
            :summary-method="stuSummaryMethod"
          >
            <el-table-column prop="name" label="员工"></el-table-column>
            <el-table-column prop="totalCount" label="资源总数" sortable></el-table-column>
            <el-table-column prop="wtotalCount" label="无效资源" sortable></el-table-column>
            <el-table-column prop="signCount" label="成交总数" sortable></el-table-column>
            <el-table-column prop="persentShow" label="转化率" sortable></el-table-column>
            <el-table-column label="转化进度" width="300">
              <template slot-scope="scope">
                <el-progress
                  :text-inside="true"
                  :stroke-width="24"
                  :percentage="scope.row.persent"
                  status="success"
                ></el-progress>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-card>
      <div style="height:20px;"></div>
      <el-card class="box-card collectCard" shadow="always" v-if="adviserList.length>0">
        <div class="clearfix" slot="header">
          <span>顾问团队转化率统计</span>
        </div>
        <div class="index-card" style="height:auto;">
          <el-table
            v-loading="loading"
            :data="adviserList"
            border
            stripe
            style="width:100%;"
            show-summary
            :summary-method="stuSummaryMethod"
          >
            <el-table-column prop="name" label="员工"></el-table-column>
            <el-table-column prop="totalCount" label="资源总数" sortable></el-table-column>
            <el-table-column prop="wtotalCount" label="无效资源" sortable></el-table-column>
            <el-table-column prop="signCount" label="成交总数" sortable></el-table-column>
            <el-table-column prop="persentShow" label="转化率" sortable></el-table-column>
            <el-table-column label="转化进度" width="300">
              <template slot-scope="scope">
                <el-progress
                  :text-inside="true"
                  :stroke-width="24"
                  :percentage="scope.row.persent"
                  status="success"
                ></el-progress>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import echarts from "echarts";
import "echarts/theme/macarons.js";
import url from "@/plugins/urlHelper.js";
import SelectAbroad from "@/components/SelectAbroad";
export default {
  data() {
    return {
      domain: url.getDomain(),
      query: { time: [],timeone:[] }, //对象
      loading: false,
      currentPage4: 1,
      pageSize: 10,
      total: 0,
      marketList: [],
      adviserList: [],
      dialogVisible: false,
      submiting: false,
      list: [], //数据详情
    };
  },
  components: {},
  methods: {
    _fmtDate(d) {
      if (!d) return '';
      var date = typeof d === 'string' ? new Date(d) : d;
      var y = date.getFullYear(), m = date.getMonth() + 1, day = date.getDate();
      return y + '-' + (m < 10 ? '0' : '') + m + '-' + (day < 10 ? '0' : '') + day;
    },
    /** 列表底部汇总行 */
    stuSummaryMethod({ columns, data }) {
      var sums = [];
      var totalCount = 0;
      var wtotalCount = 0;
      var signCount = 0;
      (data || []).forEach(function(row) {
        totalCount += Number(row.totalCount || 0);
        wtotalCount += Number(row.wtotalCount || 0);
        signCount += Number(row.signCount || 0);
      });
      var persent = totalCount === 0 ? 0 : Math.round((signCount * 1000) / totalCount) / 10;
      columns.forEach(function(col, index) {
        if (index === 0) {
          sums[index] = "汇总";
          return;
        }
        if (col.property === "totalCount") sums[index] = totalCount;
        else if (col.property === "wtotalCount") sums[index] = wtotalCount;
        else if (col.property === "signCount") sums[index] = signCount;
        else if (col.property === "persentShow") sums[index] = persent + "%";
        else sums[index] = "";
      });
      return sums;
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage4 = 1;
      this.getList();
    },
    handleCurrentChange(val) {
      this.currentPage4 = val;
      this.getList();
    },
    //筛选
    filterTag(filter) {
      var val = filter["isEnable"][0];
      this.form.isEnable = val;
      //刷新列表
      this.getList();
    },
    //排序
    sortChange(sortColumn) {
      this.form.sort = sortColumn.prop;
      this.form.order = sortColumn.order;
      //刷新列表
      this.getList();
    },
    getList: function () {
      var _this = this;
      var params = _this.query;
      var hasTime = params.time && params.time.length === 2;
      var hasTimeone = params.timeone && params.timeone.length === 2;
      // 只传日期参数，保证缴费时间/录入时间筛选被后端正确绑定（避免带 array 的 query 序列化异常）
      var requestParams = {};
      if (hasTime) {
        requestParams.start = typeof params.time[0] === 'string' ? params.time[0] : _this._fmtDate(params.time[0]);
        requestParams.end = typeof params.time[1] === 'string' ? params.time[1] : _this._fmtDate(params.time[1]);
      }
      if (hasTimeone) {
        requestParams.startone = typeof params.timeone[0] === 'string' ? params.timeone[0] : _this._fmtDate(params.timeone[0]);
        requestParams.endone = typeof params.timeone[1] === 'string' ? params.timeone[1] : _this._fmtDate(params.timeone[1]);
      }
      _this.loading = true;
      var link = url.getCollect("GetConvertStu");
      $.get(link, requestParams, (data) => {
        _this.loading = false;
        _this.adviserList = data.adviserList;
        _this.marketList = data.marketList;
        _this.total = data.total;
      });
    },
  },
  created() {},
  mounted() {
    var now = new Date();
    var start = new Date(now.getFullYear(), now.getMonth(), 1);
    var fmt = function(d) {
      var y = d.getFullYear(), m = d.getMonth() + 1, day = d.getDate();
      return y + "-" + (m < 10 ? "0" : "") + m + "-" + (day < 10 ? "0" : "") + day;
    };
    this.query.time = [fmt(start), fmt(now)];
    this.query.timeone = [fmt(start), fmt(now)];
    this.getList();
  },
};
</script>

<style scoped>
.query-form {
  margin-top: 20px;
  padding-top: 25px;
  background: #f2f2f2;
}
.el-form-item--small.el-form-item {
  margin-right: 0px;
}
.el-button--primary {
  margin-left: 10px;
}
.stateItem {
  text-align: center;
  line-height: 3em;
  padding-top: 1em;
}
.stateItem .state {
  font-size: 16px;
  line-height: 30px;
}
.stateItem .person {
  letter-spacing: 2px;
  color: #aaa;
}
</style>
